/** @jsx jsx */
import {jsx} from "theme-ui"

const Paragraph = props => (
    <p sx={{
        fontSize: 3,
        lineHeight: 'body',
        my: 5
    }}>{props.children}</p>
)

export default Paragraph